module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bubble-logo-870839be54b38c8a1a2c9da0d622acee.svg";